// extracted by mini-css-extract-plugin
export var blink = "_av-2";
export var cursor = "_av-1";
export var reactMarkdown = "_av-3";
export var streamingText = "_av-0";